import React from "react";
import { MdCancel } from "react-icons/md";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import classNames from "classnames";
import { CountryFlag } from "components/CountryFlag";

const useStyles = makeStyles({
  countryFlag: {
    paddingLeft: 10
  },
  countryName: {
    paddingLeft: 5
  }
});

export const CountryMultiValue = ({
  data: { value },
  children,
  isFocused,
  isDisabled,
  removeProps,
  selectProps
}: any) => {
  const customClasses = useStyles();

  return (
    <Chip
      tabIndex={-1}
      avatar={<CountryFlag countryCode={value} />}
      label={children}
      className={classNames(
        selectProps.classes.chip,
        customClasses.countryFlag,
        {
          [selectProps.classes.chipFocused]: isFocused
        }
      )}
      classes={{
        label: customClasses.countryName
      }}
      onDelete={!isDisabled ? removeProps.onClick : null}
      deleteIcon={<MdCancel />}
    />
  );
};

CountryMultiValue.displayName = "CountryMultiValue";
